import { render, staticRenderFns } from "./WorkClientOffices.vue?vue&type=template&id=655b5e1b&"
import script from "./WorkClientOffices.vue?vue&type=script&lang=js&"
export * from "./WorkClientOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports